import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";

const images = window.Adventure_IMAGES || [];


const Adventure = () => {


    return (

        <div class="grid grid-cols-1 md:grid-cols-[3fr_3fr_3fr] md:pad-t-150 
          gap-10 md:gap-5 lg:gap-5 xl:gap-10">
            <div>
                <img src={images[0]}
                    class='mx-auto w-2/5 md:w-3/5'
                    alt='Meeting Global Recycled Standard and predominantly made with ocean plastic recycled materials'>
                </img>
                <p class='md:pad-1 text-primary-dark mt-4 text-[4vw] md:text-[2vw] lg:text-[1vw] font-worksans pad-b-25 mx-auto md:mx-px text-center'>
                    Meeting Global Recycled Standard and predominantly made with ocean plastic recycled materials
                </p>
            </div>
            <div>
                <img src={images[1]}
                    class='mx-auto w-2/5 md:w-3/5'
                    alt='Featuring YKK Natulon Plus zippers and algae-based foam'>
                </img>

                <p class='md:pad-1 text-primary-dark mt-4 text-[3vw] md:text-[2vw] lg:text-[1vw] font-worksans pad-b-25 mx-auto md:mx-px text-center'>
                    Featuring YKK Natulon Plus zippers and algae-based foam
                </p>
            </div>
            <div>
                <img src={images[2]}
                    class='mx-auto w-2/5 md:w-3/5'
                    alt='Working towards Bluesign certification'>
                </img>
                <p class='md:pad-1 text-primary-dark mt-4 text-[3vw] md:text-[1vw] lg:text-[1vw] font-worksans pad-b-25 mx-auto md:mx-px text-center'>
                    Working towards Bluesign certification
                </p>
            </div>
        </div>
    );
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-adventure");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<Adventure />);
}
